<i18n src="@/lang/actions" />
<i18n>
    {
        "en": {
            "version": "version",
            "code": "code",
            "show_services": "Show services"
        },
        "ua": {
            "version": "версія",
            "code": "код",
            "show_services": "Показать сервисы"
        },
        "ru": {
            "version": "версия",
            "code": "код",
            "show_services": "Показати сервіси"
        }
    }
</i18n>

<template>
  <div class="widget-card">
    <el-card
      shadow="hover"
      @click.native="handleCardClick"
      :body-style="{
        height: 'calc(100% - 20px)',
        display: 'flex',
        flexDirection: 'column',
        paddingTop: '10px',
        paddingBottom: '10px'
      }"
    >
      <el-image
        class="widget-image"
        :src="widget.image"
        fit="cover"
        :lazy="false"
      />
      <div class="widget-name" v-html="widget.name"></div>
      <div
        class="widget-desc widget-info"
        v-html="widget.short_description"
      ></div>
      <div
        class="widget-desc widget-info"
        v-if="is_in_widgets"
        style="margin-top: 10px"
        v-text="(widget.uri || '').replace(/http[s]*:\/\//, '')"
      />
      <div class="bottom">
        <div class="widget-vers widget-info">
          <component
            v-if="is_in_widgets && widget.repo"
            @click.prevent="window.open(widget.repo.uri)"
            :is="require('icons/Git').default"
            :size="24"
          />
          {{ widget.code }}
          <!--                    {{ widget.code+": "+widget.version }}-->
        </div>
        <div class="w-status" v-if="is_in_widgets">
          <i
            :class="[
              'el-icon-success',
              'w--' +
                (widget.broken
                  ? 'broken'
                  : widget.enabled
                  ? 'enabled'
                  : 'disabled')
            ]"
          />
        </div>
        <div class="w-status" v-if="is_in_customer_details">
          <i
            :class="[
              'el-icon-s-opportunity',
              'w--' + (widget.active ? 'enabled' : 'disabled')
            ]"
          />
        </div>
      </div>
    </el-card>
    <component
      :is="require('./widget_details_popup').default"
      :widget="widget"
      :visible.sync="show_details"
    >
      <template v-slot:widget-info="scope">
        <div class="widget-dev widget-info">
          <div class="widget-col">
            <div
              class="widget-desc widget-info"
              v-if="is_in_widgets"
              style="margin-top: 10px; margin-bottom: 10px"
              v-text="(widget.uri || '').replace(/http[s]*:\/\//, '')"
            />
            <div class="widget-val">
              <component
                v-if="is_in_widgets && scope.widget.repo"
                @click="window.open(widget.repo.uri)"
                :is="require('icons/Git').default"
                :size="24"
              />
              {{ widget.code }}
            </div>
            <div class="widget-text">{{ $t("code") }}</div>
            <div class="widget-upd" v-text="widget.updated_at" />
          </div>
          <!--                    <div class="widget-col">-->
          <!--                        <div class="widget-val">{{ widget.version }}</div>-->
          <!--                        <div class="widget-text">{{ $t("version") }}</div>-->
          <!--                    </div>-->
        </div>
      </template>
      <template v-slot:actions="scope">
        <slot name="actions" v-bind:widget="scope">
          <template v-if="is_in_widgets">
            <el-button-group>
              <el-button
                :key="JSON.stringify(scope.widget.uuid && !edit_mode)"
                :size="btnSize"
                :type="!scope.widget.enabled ? 'primary' : ''"
                v-text="scope.widget.enabled ? 'Disable' : 'Enable'"
                v-if="scope.widget.uuid && !edit_mode"
                @click="
                  () => {
                    scope.widget.toggleWidgetEnabled();
                  }
                "
              />
              <el-button
                :size="btnSize"
                v-t="'actions.' + (edit_mode ? 'cancel' : 'edit')"
                @click="edit_mode = !edit_mode"
              />
              <el-button
                :size="btnSize"
                type="danger"
                v-t="'actions.delete'"
                v-if="scope.widget.uuid && !edit_mode"
                @click="handleDeleteWidget(scope.widget)"
              />
            </el-button-group>
            <el-button
              style="margin-top: 20px"
              type="info"
              v-t="'show_services'"
              v-if="scope.widget.uuid && !edit_mode"
              @click="
                () => {
                  $store.commit(
                    'shared_customers_services_list/clearAllFilters'
                  );
                  $store.state.shared_customers_services_list.filter_string =
                    scope.widget.code;
                  $store.commit(
                    'shared_customers_services_list/addToFilterStrings'
                  );
                  $router.push({ name: 'customers-services-v3' });
                }
              "
            />
          </template>
          <template v-if="is_in_customer_details">
            <el-button
              :size="btnSize"
              type="primary"
              v-text="scope.widget.active ? 'Update' : 'Install'"
              @click="$emit('installWidget', scope.widget)"
            />
            <el-button
              :size="btnSize"
              type="primary"
              v-text="'Promo'"
              :disabled="!amo || !amo.password"
              @click="$emit('installIntegration', [scope.widget, 'promo'])"
            />
          </template>
        </slot>
      </template>
      <template v-slot:main>
        <slot name="main" v-bind:widget="model">
          <div v-if="!edit_mode" v-html="model.description" />
          <widget-edit
            v-else
            :widget.sync="model"
            :edit-mode.sync="edit_mode"
          />
        </slot>
      </template>
    </component>
  </div>
</template>

<script>
import WidgetEdit from "./widget_edit";
import { mapMutations } from "vuex";
import SharedWidgets from "../../../store/classes/SharedWidgets";

export default {
  name: "widget_card",
  components: { WidgetEdit },
  props: {
    widget: {
      type: Object,
      default: () => ({})
    },
    is_in_widgets: {
      type: Boolean,
      default: false
    },
    is_in_customer_details: {
      type: Boolean,
      default: false
    },
    editMode: {
      type: Boolean,
      default: false
    },
    amo: {
      type: Object,
      default: null
    },
    clickHandler: Function
  },
  data() {
    return {
      btnSize: "small",
      show_details: false,
      window: window,
      edit_mode: this.editMode,
      model: new SharedWidgets(JSON.parse(JSON.stringify(this.widget)))
    };
  },
  mounted() {
    if (!this.widget.uuid) {
      this.show_details = true;
      this.edit_mode = true;
    }
  },
  methods: {
    ...mapMutations("shared_widgets_list", ["removeEmptyModel"]),
    handleCardClick(e) {
      if (e.shiftKey && e.altKey && e.altKey) {
        this.model.toggleWidgetEnabled().then(v => {
          this.$emit("update:widget", this.model);
        });
        return;
      }
      if (e.toElement && e.toElement.tagName === "svg") {
        return;
      }
      if (this.clickHandler) {
        return this.clickHandler();
      }
      this.show_details = true;
    },
    handleDeleteWidget(widget) {
      this.$confirm(
        "This will permanently delete the widget from system. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        }
      )
        .then(() => {
          widget.delete();
        })
        .catch(() => {});
    }
  },
  watch: {
    edit_mode(v) {
      if (!v && !this.model.uuid) {
        this.removeEmptyModel();
      }
      this.$emit("update:editMode", v);
    },
    model: {
      handler: function() {
        this.$emit("update:widget", this.model);
      },
      deep: true
    },
    show_details(v) {
      if (!v && !this.model.uuid) {
        this.removeEmptyModel();
      }
    }
  }
};
</script>

<style lang="stylus">
.el-dialog__body {
    word-break: normal;
}

.widget-info {
    .git-icon {
        cursor: pointer;
        color: #F05133;
    }
}
</style>

<style lang="stylus" scoped>
.widget-upd
    margin-top 24px
    &:before
        content "UPD:"
        margin-right 10px
        opacity .5

.widget-card {
    display: inline-block;
    padding: 0 !important;
    border-width: 0 !important;
    width: 222px;
    margin: 0 auto 20px;
    cursor: pointer;
}

.el-card {
    height: 100%;
}

.widget-image {
    width: 182px;
    height: 108px;
    border-radius: 6px;
    margin-bottom: 10px;
    border: 1px solid #f3f3f3;
}

.widget-name {
    font-weight: bold;
}

.widget-info {
    font-size: 12px;
    color: #92989b;
    line-height: 14px;
    margin-top: 3px;
    flex: 1 1;
}

.widget-vers {
    font-weight: bold;
}

.bottom {
    display: flex;
    justify-content: space-between;
}
</style>
